import "@/App.css";
import { useEffect, lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { motion, useScroll, MotionConfig } from "framer-motion";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";
import Home from "@/pages/Home";
const WhyWebsite = lazy(() => import("@/pages/WhyWebsite"));
const Work = lazy(() => import("@/pages/Work"));
const Services = lazy(() => import("@/pages/Services"));
const About = lazy(() => import("@/pages/About"));
const Contact = lazy(() => import("@/pages/Contact"));
const Admin = lazy(() => import("@/pages/Admin"));

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  return (
    <motion.div
      data-testid="scroll-progress-bar"
      className="fixed left-0 top-0 z-[60] h-[3px] w-full origin-left bg-black"
      style={{ scaleX: scrollYProgress }}
    />
  );
};

function App() {
  useEffect(() => {
    if (window.matchMedia("(pointer: coarse), (prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <MotionConfig reducedMotion="user">
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <ScrollProgress />
        <Nav />
        <Suspense fallback={<main data-testid="page-loading" role="status" className="container-x min-h-[70svh] pt-40 text-sm">Loading…</main>}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/why" element={<WhyWebsite />} />
          <Route path="/work" element={<Work />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        </Suspense>
        <Footer />
        <Toaster position="bottom-right" />
      </BrowserRouter>
    </div>
    </MotionConfig>
  );
}

export default App;
